import BayHireContainer from "@features/bay-hire/BayHireContainer";
import BayHireHistoryQueue from "@features/bay-hire/components/BayHireHistoryQueue/BayHireHistoryQueue";
import BayHireOperationsQueue from "@features/bay-hire/components/BayHireOperationsQueue/BayHireOperationsQueue";
import BayHireOperationsTabs from "@features/bay-hire/components/BayHireOperationsQueue/BayHireOperationsTabs";
import BayHireRequestDetail from "@features/bay-hire/components/BayHireRequestDetail/BayHireRequestDetail";
import BayHireWaitingListQueue from "@features/bay-hire/components/BayHireWaitingListQueue/BayHireWaitingListQueue";
import BayHireRequestFormPage from "@features/bay-hire/components/form/BayHireRequestFormPage";
import BayHirePage from "@pages/bay-hire/BayHirePage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getBayHireRoutes = (): AppRoute => ({
  path: paths.bayHire.index,
  protected: true,
  element: <BayHirePage />,
  requiredPermissions: ["hasBayHireAccess"],
  children: [
    { index: true, element: <BayHireContainer /> },
    // DFT-0027 (Slice B1): dedicated full-page vendor request detail route
    // (relative to the bay-hire parent), mirroring gatepass/licenses configs.
    { path: "request-details/:id", element: <BayHireRequestDetail /> },
    // DFT-0096 (2026-09-02): no `:id` variant - see navigation.tsx's own comment
    // on paths.bayHire.request.
    { path: "request", element: <BayHireRequestFormPage /> },
    // DFT-0027 (Slice E1): the Ongoing queue and the manual waiting-list view
    // are tabs of one Operations page (Figma p13/p21), so "operations" is
    // now a parent route rendering the router-driven tabs container (mirrors
    // vesselCallRoutes' OperationsContainer). The URLs are unchanged
    // (/bay-hire/operations and /bay-hire/operations/waiting-list), so both
    // tabs stay deep-linkable and paths.bayHire.* need no change.
    //
    // Megaplan (2026-08-05, Operations 3-tab restructure): a 3rd sibling,
    // "history", holds resolved/terminal requests (APPROVED/REJECTED/
    // CANCELLED) - see useBayHireOperationsQueue.tsx's STATUSES_BY_VIEW for
    // the full 3-way status partition this introduces.
    {
      path: "operations",
      element: <BayHireOperationsTabs />,
      children: [
        { index: true, element: <BayHireOperationsQueue /> },
        // DFT-0015: manual waiting-list view, sibling to the Ongoing queue.
        { path: "waiting-list", element: <BayHireWaitingListQueue /> },
        { path: "history", element: <BayHireHistoryQueue /> },
      ],
    },
  ],
});
